import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    assignTicket,
    changeTicketState,
    getTickets,
} from '../../../shared/services/tickets';
import ConfirmModal from '../../../shared/components/ConfirmModal';
import { useDispatch } from 'react-redux';
import { updatePresupuestosState } from '../../../../../../redux/presupuestos';
import InfoModal from '../../../shared/components/InfoModal';
import TicketsTable from './componentes/TicketsTable';
import TicketsFilter from './componentes/TicketsFilter';
import TicketsTabs from './componentes/TicketsTabs';
import ChangeStateForm from './componentes/ChangeStateForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const states = ['nuevo', 'contactado', 'archivado'];

const TicketsModal = ({
    currentPresupuesto,
    onClose,
    currentState,
}) => {
    const [tab, setTab] = useState('nuevo');
    const [tickets, setTickets] = useState([]);
    const [filteredResults, setFilteredResults] = useState(null);
    const [selectedUser, setSelectedUser] = useState('Todos');
    const [isLoading, setIsLoading] = useState(true);
    const [ticketToConfirm, setTicketToConfirm] = useState(null);
    const [currentTicket, setCurrentTicket] = useState(null);

    const dispatch = useDispatch();

    const handleChangeTab = (e, newTab) => {
        setTab(newTab);
        setTickets([]);
        setFilteredResults([]);
        getTicketsRequest(newTab);
    };

    const handleFilterByUsername = (username) => {
        setSelectedUser(username);
        if (username === 'Todos') return setFilteredResults(tickets);
        const filteredArr = tickets.filter((pendiente) =>
            pendiente.crafted_by.username.includes(username)
        );
        setFilteredResults(filteredArr);
    };

    const getTicketsRequest = async (newTab = null) => {
        setIsLoading(true);
        try {
            let entityId = null;
            if (currentPresupuesto) {
                entityId = currentPresupuesto.entity_id;
            }
            const currentTab = newTab ? newTab : tab;
            const res = await getTickets(currentTab, entityId);
            if (res?.success) {
                setTickets(res.data);
                return setFilteredResults(res.data);
            }
            toast.error('Algo ha ido mal...');
        } catch (e) {
            toast.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleConfirm = async (confirm) => {
        if (confirm) {
            try {
                if (isLoading === ticketToConfirm.id) return;
                setIsLoading(ticketToConfirm.id);
                const res = await assignTicket(
                    ticketToConfirm.id,
                    currentPresupuesto.id
                );
                if (res.success) {
                    toast.success('Ticket asignado correctamente!');
                    dispatch(
                        updatePresupuestosState(
                            currentState,
                            currentPresupuesto.id,
                            ticketToConfirm.id
                        )
                    );
                    return onClose();
                }
                toast.error('Algo ha ido mal...');
            } catch (e) {
                toast.error(e.message);
            } finally {
                setIsLoading(false);
            }
        }
        setTicketToConfirm(null);
    };

    const handleChangeTicketState = async (data) => {
        try {
            if (isLoading) return;
            setIsLoading(true);
            if (data.newState === tab) return;
            const res = await changeTicketState(data);
            if (res?.success) {
                const newTicketsArr = tickets.filter(
                    (ticket) => ticket.id !== data.ticketId
                );
                setTickets(newTicketsArr);
                setFilteredResults(newTicketsArr);
                setCurrentTicket(null);
                toast.success('Estado modificado correctamente');
            }
        } catch (e) {
            toast.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleState = (ticket) => {
        setCurrentTicket(ticket);
    };

    useEffect(() => {
        getTicketsRequest();
    }, []);

    return (
        <div className="tickets">
            <div className="w-100 mb-3 pt-2 d-flex flex-row align-items-center justify-content-between">
                <TicketsFilter
                    tickets={tickets}
                    handleFilterByUsername={handleFilterByUsername}
                    selectedUser={selectedUser}
                />
                {!currentPresupuesto && (
                    <Link to={'/presupuesto/0'}>
                        <button className="btn btn-add">
                            <span className="add">
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    size="1x"
                                    className="action"
                                    color="#215732"
                                />
                            </span>
                            Nuevo presupuesto
                        </button>
                    </Link>
                )}
            </div>
            {currentPresupuesto ? (
                <TicketsTable
                    filteredResults={filteredResults}
                    currentPresupuesto={currentPresupuesto}
                    isLoading={isLoading}
                    setTicketToConfirm={setTicketToConfirm}
                />
            ) : (
                <TicketsTabs
                    tab={tab}
                    handleChangeTab={handleChangeTab}
                    filteredResults={filteredResults}
                    isLoading={isLoading}
                    handleState={handleState}
                    states={states}
                />
            )}
            {ticketToConfirm && (
                <ConfirmModal
                    onConfirmAction={handleConfirm}
                    title={`Asignar ticket al presupuesto ${currentPresupuesto?.numero}`}
                    description={'¿Estás seguro de que quieres asignarlo?'}
                    state={ticketToConfirm}
                    onClose={() => setTicketToConfirm(null)}
                ></ConfirmModal>
            )}
            {currentTicket && (
                <InfoModal
                    state={currentTicket}
                    title={
                        'Cambio estado ticket'
                    }
                    content={
                        <ChangeStateForm
                            currentTicket={currentTicket}
                            changeTicketState={handleChangeTicketState}
                            tab={tab}
                            isLoading={isLoading}
                            states={states}
                        />
                    }
                    width={'sm'}
                    onClose={() => setCurrentTicket(null)}
                ></InfoModal>
            )}
        </div>
    );
};

export default TicketsModal;
